import { QueryParamAdapterComponent } from "use-query-params";
import { useLocation, useNavigate } from "@tanstack/react-router";

export const TanstackRouterQueryParamsAdapter: QueryParamAdapterComponent = ({
  children,
}) => {
  const navigate = useNavigate();
  const routerLocation = useLocation();

  return children({
    replace(location) {
      void navigate({
        to: ".",
        search: parseSearchParams(location.search),
        replace: true,
      });
    },
    push(location) {
      void navigate({ to: ".", search: parseSearchParams(location.search) });
    },
    get location() {
      return {
        search: routerLocation.searchStr,
        state: routerLocation.state,
      };
    },
  });
};

function parseSearchParams(search: string) {
  return Object.fromEntries(
    [...new URLSearchParams(search).entries()].map(([key, value]) => [
      key,
      /^\d+$/.test(value) ? Number(value) : value,
    ]),
  );
}
